export const ROLE_SUPER_ADMIN = 1;
export const ROLE_ACCT_ADMIN = 2;
export const ROLE_ACCT_USER = 3;
export const ROLE_CLIENT = 4;
export const ROLE_EMPLOYEE = 5;
export const PAYROLL_TYPE_REG = 45;
export const PAYROLL_TYPE_OFFCYCLE = 46;
export const PAYROLL_TYPE_13TH_MONTH = 47;
export const PAY_STAT_DRAFT = 48;
export const PAY_STAT_INPROGRESS = 49;
export const PAY_STAT_VALIDATED = 50;
export const PAY_STAT_APPROVED = 51;
export const PAY_STAT_RELEASED = 52;
export const MODULE_DASHBOARD = 6;
export const MODULE_TEAM_MENU = 7;
export const MODULE_CLIENT = 8;
export const MODULE_EMPLOYEES = 9;
export const MODULE_SALARIES = 10;
export const MODULE_PAYROLL_MENU = 11;
export const MODULE_PAYROLLS = 12;
export const MODULE_SAL_ADJUSTMENTS = 13;
export const MODULE_SAL_DEDUCTIONS = 14;
export const MODULE_SAL_ADDITIONS = 15;
export const MODULE_FINAL_PAYS = 16;
export const MODULE_FINANCE = 17;
export const MODULE_INVOICES = 18;
export const MODULE_MANUAL_JOURNALS = 19;
export const MODULE_CLIENT_EXPENSE= 20;
export const MODULE_INVOICE_ADJUSTMENTS = 21;
export const MODULE_REPORTS = 22;
export const MODULE_ACCESS_MANAGEMENT_MENU = 23;
export const MODULE_ACCESS_MANAGER = 24;
export const MODULE_USERS = 25;
export const MODULE_ACCESS_GROUPS = 26;
export const MODULE_ACCESS_RIGHTS = 27;
export const MODULE_MODULES = 28;
export const MODULE_SETTINGS_MENU = 29;
export const MODULE_HOLIDAYS = 30;
export const MODULE_OPTION_GROUPS = 31;
export const MODULE_OPTIONS = 32;
export const MODULE_PAYCODES = 33;
export const MODULE_USER_GUIDE = 34;
export const MODULE_SYSTEM_CHECK = 35;
export const MODULE_TIMEKEEPING = 36;
export const MODULE_TIMECARDS = 37;
export const MODULE_OVERTIME = 38;
export const MODULE_LEAVE = 39;
export const MODULE_MYPAYSLIPS = 40;
export const MODULE_RECRUITMENT = 41;
export const MODULE_JOB_POSTS = 42;
export const MODULE_RECRUITMENT_OVERVIEW = 43;
export const MODULE_JOBROLES = 44;
export const MODULE_JOBROLE_REQS = 45;
export const MODULE_TRAINING = 46;
export const MODULE_TRAINING_MOD = 47;
export const MODULE_TRAINING_REQ = 48;
export const MODULE_TRAINING_CLASS = 49;
export const MODULE_TRAINING_OVERVIEW = 50;
export const MODULE_TRAINING_AND_DEV = 51;
export const MODULE_TRAINING_MY_COURSES = 52;
export const MODULE_BROWSE_TRAINING = 53;
export const MODULE_CERTIFICATIONS = 54;
export const MODULE_PERFORMANCE_GOALS = 55;
export const MODULE_AWARDS_RECOGNITION = 56;  
export const MODULE_AWARDS = 57; 
export const MODULE_REWARDS = 58; 
export const MODULE_MY_AWARDS = 59;  
export const MODULE_MY_POINTS = 60; 
export const MODULE_RECOG_WALL = 61; 
export const MODULE_APPROVAL_AWARDS = 62; 
export const MODULE_INBOX = 63;
export const MODULE_SUPP_TICKETS = 64;
export const MODULE_MY_DOCS = 65;
export const MODULE_EMP_DETAILS = 66;
export const MODULE_TEAM_OVERVIEW = 67;
export const MODULE_REVIEWS = 68;
export const MODULE_PERF_IMPROVS = 69;
export const MODULE_PRODUCTIVITY = 70;
export const MODULE_LEAVE_REQUESTS = 71;
export const MODULE_TEAM_ABSENCES = 72;
export const MODULE_ATTENDANCE_OVERVIEW = 73;
export const MODULE_HYVIDSTORE = 74;
export const MODULE_OVERTIME_REQUESTS = 75;
export const MODULE_AI_CHAT = 76;
export const MODULE_AI_COPILOT = 77;
export const MODULE_HOUSE_RULES = 0; 
export const MODULE_COUNTRY_GUIDE = 0; 
export const MODULE_TOOLS = 79;
export const MODULE_SN_CALCULATOR = 80;
export const MODULE_APPROVAL_REWARDS = 78; 
export const MODULE_PURCHASE_ORDER = 81;
export const MY_INVOICES = 82;
export const MY_ATTENDANCE = 83;
export const MODULE_ASSET_MANAGEMENT = 84;
export const MODULE_ASSIGNED_ASSETS = 85;
export const MODULE_CLIENT_REFERRAL = 86;
export const MY_ACTAS_USR = 87;
export const MODULE_EMPLOYEE_REFERRAL = 88;
export const MODULE_SCHEDULE_TEMPLATES = 89;
export const MODULE_ANNOUNCEMENTS = 90;
export const MODULE_HYVID_CHAT = 92;
export const MODULE_EMP_LEAVE_CREDITS = 92;
